@if (isBackendUnavailable()) {
  <app-backend-unavailable></app-backend-unavailable>
} @else {
  <div class="app-container">
    @if (navigationVisible()) {
      <app-menu-bar></app-menu-bar>
    }
    <app-side-nav class="content" [navigationVisible]="navigationVisible()">
      <router-outlet
        #outlet="outlet"
        (activate)="onRouteActivated(outlet)"
      ></router-outlet>
    </app-side-nav>
  </div>
}
